var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('singleList',{attrs:{"setup":_vm.setup,"list":_vm.list},on:{"callBack":_vm.open}}),_c('singleList',{attrs:{"setup":_vm.setup1,"list":_vm.list2},on:{"callBack":_vm.open}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }